import React, { Component } from "react";
import styled from "styled-components";
import { conditionNames, getFilteredClauseTree } from "@appcues/libcues";

import { filterTriggerClauses } from "utils/conditions";

import Radio from "components/Common/UI/Forms/Radio";
import FrequencyTargeting from "components/Common/FrequencyTargeting";
import ConfigureCustomEventTrigger from "./ConfigureCustomEventTrigger";

const StyledConfigureCustomEventTrigger = styled(ConfigureCustomEventTrigger)`
  margin-left: 23px;
`;

class EventTriggering extends Component {
  getTriggerClause = () => {
    const { clauses } = this.props;
    const triggerClauses = getFilteredClauseTree(filterTriggerClauses, clauses);
    return triggerClauses.find(
      clause => clause.conditionName === conditionNames.TRIGGER
    );
  };

  onClickPageTrigger = () => {
    const { stepId, setStepFrequency, deleteMatchingClauses } = this.props;
    deleteMatchingClauses(stepId, filterTriggerClauses);
    setStepFrequency(stepId, "once");
  };

  onClickEventTrigger = () => {
    const {
      stepId,
      setStepFrequency,
      deleteMatchingClauses,
      addClause
    } = this.props;

    setStepFrequency(stepId, "once");
    deleteMatchingClauses(stepId, filterTriggerClauses);
    addClause(stepId, null, {
      conditionName: conditionNames.TRIGGER,
      event: ""
    });
  };

  onClickManualTrigger = () => {
    const { stepId, setStepFrequency, deleteMatchingClauses } = this.props;
    deleteMatchingClauses(stepId, filterTriggerClauses);
    setStepFrequency(stepId, "never");
  };

  updateTriggerClause = changes => {
    const { stepId, updateClause } = this.props;
    const triggerClause = this.getTriggerClause();

    updateClause(stepId, triggerClause.id, changes);
  };

  render() {
    const {
      rule,
      setStepFrequency,
      hasEventTriggering,
      hasEventTriggeringWithAttributes
    } = this.props;

    const triggerClause = this.getTriggerClause();
    const isManualTrigger = rule.frequency === "never";
    const isEventTrigger = !isManualTrigger && !!triggerClause;
    const isPageTrigger = !isManualTrigger && !triggerClause;

    return (
      <div>
        <h4>When should this flow launch?</h4>
        <div className="targeting-container">
          <div className="conditions-container">
            <Radio
              label="When the user reaches the page"
              onClick={this.onClickPageTrigger}
              id="page-trigger-radio"
              checked={isPageTrigger}
            />
            {hasEventTriggering && (
              <Radio
                label="When an event occurs"
                onClick={this.onClickEventTrigger}
                id="event-trigger-radio"
                checked={isEventTrigger}
              />
            )}
            {isEventTrigger && (
              <StyledConfigureCustomEventTrigger
                triggerClause={triggerClause}
                updateTriggerClause={this.updateTriggerClause}
                hasEventTriggeringWithAttributes={
                  hasEventTriggeringWithAttributes
                }
              />
            )}
            <Radio
              label="Only manually (from permalink, widget, or checklist)"
              onClick={this.onClickManualTrigger}
              checked={isManualTrigger}
              id="manual-trigger-radio"
            />
          </div>
        </div>
        {!isManualTrigger && (
          <FrequencyTargeting
            setStepFrequency={setStepFrequency}
            stepId={rule.id}
            stepFrequency={rule.frequency}
            showManualTriggerOption={false}
          />
        )}
      </div>
    );
  }
}

export default EventTriggering;
